<c11n-spinner
    id="loading-indicator"
    [size]="'medium'"
    [colorMode]="'on-light'"
    [spinnerStatus]="'loading'">
</c11n-spinner>
